import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export enum ClientDashboardComponentIndexType {
  HOME = '#home',
  RENTAL_HISTORY = '#rental-history',
  SUBSCRIPTIONS = '#subscriptions',
  MY_INFORMATION = '#my-information',
  PAYMENT_METHODS = '#payment-methods',
  PASSWORD = '#password',
}
type InitialState = {
  currentComponentIndex: ClientDashboardComponentIndexType;
  pageTitles: Record<ClientDashboardComponentIndexType, string>;
};
const initialState: InitialState = {
  currentComponentIndex: Object.values(
    ClientDashboardComponentIndexType,
  ).includes(window.location.hash as ClientDashboardComponentIndexType)
    ? (window.location.hash as ClientDashboardComponentIndexType)
    : ClientDashboardComponentIndexType.HOME,
  pageTitles: {
    [ClientDashboardComponentIndexType.HOME]: 'Home',
    [ClientDashboardComponentIndexType.RENTAL_HISTORY]: 'Rental history',
    [ClientDashboardComponentIndexType.SUBSCRIPTIONS]: 'Subscriptions',
    [ClientDashboardComponentIndexType.MY_INFORMATION]: 'My Information',
    [ClientDashboardComponentIndexType.PAYMENT_METHODS]: 'Payment methods',
    [ClientDashboardComponentIndexType.PASSWORD]: 'Password',
  },
};
export const clientDashboardSlice = createSlice({
  name: 'clientDashboard',
  initialState,
  reducers: {
    setClientDashboardContentIndex: (
      state,
      action: PayloadAction<ClientDashboardComponentIndexType>,
    ) => {
      return {
        ...state,
        currentComponentIndex: action.payload,
      };
    },
  },
});
